// extracted by mini-css-extract-plugin
export var slider = "ImageGalleryComponentStyle-module--slider--2Y80d";
export var sliderWrapper = "ImageGalleryComponentStyle-module--slider-wrapper--2Kd7L";
export var slide = "ImageGalleryComponentStyle-module--slide--29L74";